/**
 * Local per-list “Manage Rights” policy (localStorage) for non-Candidates lists.
 * Candidates use candidatesListPreferences.ts (masking + extended columns).
 */

export type ListRightsUserRow = {
  canRead: boolean;
  canWrite: boolean;
  canDelete: boolean;
  canOperateChildren: boolean;
};

export function normalizeListRightsUserRow(raw: Partial<ListRightsUserRow> | undefined): ListRightsUserRow {
  return {
    canRead: raw?.canRead !== false,
    canWrite: Boolean(raw?.canWrite),
    canDelete: Boolean(raw?.canDelete),
    canOperateChildren: Boolean(raw?.canOperateChildren),
  };
}

export interface GenericListRightsPolicy {
  userAccess: Record<string, ListRightsUserRow>;
}

export function defaultGenericListRightsPolicy(): GenericListRightsPolicy {
  return { userAccess: {} };
}

function storageKey(orgId: string, entityKey: string) {
  return `ggj:listRights:${entityKey}:${orgId}`;
}

export function loadGenericListRightsPolicy(orgId: string, entityKey: string): GenericListRightsPolicy {
  try {
    const raw = localStorage.getItem(storageKey(orgId, entityKey));
    if (!raw) return defaultGenericListRightsPolicy();
    const p = JSON.parse(raw) as Partial<GenericListRightsPolicy>;
    const ua = p.userAccess && typeof p.userAccess === 'object' ? p.userAccess : {};
    const userAccess: Record<string, ListRightsUserRow> = {};
    for (const [id, v] of Object.entries(ua)) {
      userAccess[id] = normalizeListRightsUserRow(v as Partial<ListRightsUserRow>);
    }
    return { userAccess };
  } catch {
    return defaultGenericListRightsPolicy();
  }
}

export function saveGenericListRightsPolicy(orgId: string, entityKey: string, policy: GenericListRightsPolicy) {
  localStorage.setItem(storageKey(orgId, entityKey), JSON.stringify(policy));
}
